import { useMutation } from '@apollo/client';
import { UpdateProductMediaMutation, UpdateProductMediaMutationVariables } from '_graphql/mutation/__generated__/graphql';
import { UPDATE_PRODUCT_MEDIA } from '_graphql/mutation/products';

export const useUpdateProductMedia = (
  variables?: UpdateProductMediaMutationVariables
) => {
  const [updateProductMedia, { ...rest }] = useMutation<
    UpdateProductMediaMutation,
    UpdateProductMediaMutationVariables
  >(UPDATE_PRODUCT_MEDIA, {
    variables,
    refetchQueries: ['GetProduct'],
  });
  return {
    ...rest,
    updateProductMedia,
  };
};
